/**
 *  事件管理中心，用于监听，派发事件
 *  @author huangyiustb
 *  @email huangyiustb@didichuxing.com
 */
let _listenerMap = {};

function call(callback, args) {
	let fn = callback[0];
	let context = callback[1];
	args = callback[2].concat(args);
	try {
		return fn.apply(context, args);
	} catch (e) {
		setTimeout(function () {
			throw e;
		}, 0);
	}
}

function arrayClone(arr, len) {
	let copy = new Array(len);
	while (len--) {
		copy[len] = arr[len];
	}
	return copy;
}

function emit(type, ...args) {
	let listenerList = _listenerMap[type];
	if (!listenerList) {
		return true;
	}
	let len = listenerList.cbs.length;
	let cbs = arrayClone(listenerList.cbs, len);
	let ret = true;
	for (let index = 0; index < len; index++) {
		if (!cbs[index]) {
			continue;
		}
		ret = call(cbs[index], args) !== false && ret;
	}
	return !!ret;
}

export const events = {
	on: function (type, fn, context, ...rest) {
		let listenerList = _listenerMap[type];
		if (!listenerList) {
			_listenerMap[type] = listenerList = {
				args: null,
				cbs: []
			};
		}

		let callback = [fn, context, rest];
		let args = listenerList.args;
		if (args) {
			call(callback, args);
		} else {
			listenerList.cbs.push(callback);
		}
	},
	un: function (type, fn) {
		let listenerList = _listenerMap[type];
		if (!listenerList) {
			return true;
		}
		if (arguments.length === 1) {
			listenerList.cbs = [];
		} else {
			let cbs = listenerList.cbs;
			let count = cbs.length;
			while (count--) {
				if (cbs[count] && cbs[count][0] === fn) {
					cbs.splice(count, 1);
				}
			}
		}
	},
	emit: function (type, args) {
		return emit.apply(this, arguments);
	},
	done: function (type, ...args) {
		let listenerList = _listenerMap[type];
		if (!listenerList) {
			_listenerMap[type] = listenerList = {
				args: args,
				cbs: []
			};
		}
		let cbs = listenerList.cbs;
		let count = cbs.length;
		emit.apply(this, arguments);

		listenerList.args = args;
		listenerList.cbs = cbs.slice(count);
	},
	undo: function (type) {
		let listenerList = _listenerMap[type];
		if (!listenerList) {
			return false;
		}
		listenerList.args = null;
	}
};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/util/events.js